import { Component, OnInit, OnDestroy } from '@angular/core';
import { GlobalService } from '../../core/services/global/global.service';
import { Subject, takeUntil } from 'rxjs';
import { NadaSpinnerComponent } from '../../shared/components/nada-spinner/nada-spinner.component';

@Component({
  selector: 'app-my-analyst',
  standalone: true,
  imports: [NadaSpinnerComponent],
  templateUrl: './my-analyst.component.html',
  styleUrl: './my-analyst.component.css',
})
export class MyAnalystComponent implements OnInit, OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();
  analystInfo: any;
  isProcessing: boolean = false;
  selectedDealer: string = '';

  constructor(private globalService: GlobalService) {}
  ngOnInit() {
    this.globalService.groupMemberCode$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(async (data) => {
        if (this.selectedDealer === data) return;
        this.selectedDealer = data;
        this.getAnalystInfo();
      });
  }

  async getAnalystInfo() {
    if (!this.selectedDealer) return;
    this.isProcessing = true;
    try {
      const response = await this.globalService.getAnalystInfo(
        this.selectedDealer,
      );
      if (response.statusCode === 200) {
        this.analystInfo = response.data;
      } else {
        this.analystInfo = null;
      }
    } catch {
      this.analystInfo = null;
    } finally {
      this.isProcessing = false;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
